const serviceLayoutPlugin = {
  Renderer: ({ children, data }) => <div>{children}</div>,
  id: "serviceLayoutPlugin",
  title: "Services Layout plugin",
  description: "Services layout plugin",
  version: "serviceLayoutPlugin",
};

export default serviceLayoutPlugin;
